import {DataFetcher} from '@aboutyou/data-fetcher';
import {useBasketToken} from '@aboutyou/user';
import React from 'react';
import {useBasketTokenSection} from '../hooks/useGetBasketPageSection';
import {BasketPageTokenUpdaterView} from './BasketPageTokenUpdaterView';

export const BasketPageTokenUpdater = () => {
  const {updateBasketToken} = useBasketToken();
  return (
    <DataFetcher
      request={useBasketTokenSection({
        onSuccess(data) {
          updateBasketToken(data.basketToken);
        },
      })}
      Error={null}
      View={BasketPageTokenUpdaterView}
    />
  );
};
